import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardBody, Col, Row, ListGroup, ListGroupItem, Modal, ModalBody, Button, Spinner } from 'reactstrap';
import { fetchOpenPositions, selectOpenPositions, addPosition, removePosition } from '../../../rtk/slices/openPositionsSlice/openPositionsSlice';
import { selectSymbols, setClickedSymbolData } from '../../../rtk/slices/tradingSlice/tradingSlice';
import AccountDetails from '../AccountDetails';
import { useLocation, useNavigate } from 'react-router-dom';
import { setSelectedSymbol } from '../../../rtk/slices/tradingSlice/tradingSlice';
import { subscribeToOrderChannel, unsubscribeFromOrderChannel } from '../../../utils/pusher-2';
import { setTP } from '../../../rtk/slices/openPositionsSlice/openPositionsSlice';
import { calculateProfitMargin, handleBulkOrderClose, handleCloseAllPressedSymbolOrders, handleCloseAllPressedSymbolSellOrders, handleLosingPositionsClose, handleSellOrdersClose, handleTouchStart } from './funtions';
import { connectToTradeSocket, disconnectFromTradeSocket } from '../../../utils/tradeSocket';
import { fetchAccountDetails } from '../../../rtk/slices/account-detail/accountDetailSlice';


const OpenPositionsMobile = ({ toggleTab }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation()
  const longPressTimeout = useRef(null);
  const { positions } = useSelector(selectOpenPositions);
  const { loading, error } = useSelector((state) => state.openPositions);
  const symbols = useSelector(selectSymbols);

  const [longPressedPosition, setLongPressedPosition] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
  const [calculatedProfits, setCalculatedProfits] = useState({});
  const [totalProfit, setTotalProfit] = useState(0);
  const [totalMargin, setTotalMargin] = useState(0);
  const [currentPriceLp, setCurrentPriceLp] = useState(null);
  const [cp, setCp] = useState(0)

  const user = JSON.parse(localStorage.getItem('user'));
  const account = user ? user.account : null;

  const modalSymbolData = symbols[longPressedPosition?.symbol];
  const modalCurrentPrice = longPressedPosition?.type === 'BUY' ? modalSymbolData?.bid : modalSymbolData?.ask;
  let modalDelta = (modalCurrentPrice - longPressedPosition?.price) * 1000
  let deltaPercentageChange = (modalDelta / (longPressedPosition?.price * 1000)) * 100
  /*  let modalDelta = 0
  
    if(longPressedPosition?.type === 'SELL'){
      console.log(longPressedPosition?.type)
      modalDelta = (modalCurrentPrice - longPressedPosition?.price) * 1000
      // modalDelta =(longPressedPosition?.price - modalCurrentPrice) * 1000
    }else{
      console.log(modalCurrentPrice +"-"+ longPressedPosition?.price)
      modalDelta = (modalCurrentPrice - longPressedPosition?.price) * 1000
    }*/

  useEffect(() => {
    Object.keys(symbols).forEach((symbol) => {
      // const { ask, bid } = symbols[symbol];
      // updatePriceProfit(symbol, ask, bid);
      calculateProfitMargin(positions, symbols, setCalculatedProfits, setTotalProfit, setTotalMargin, dispatch, setTP, totalProfit);
    });
  }, [symbols, positions]);

   useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user'));
      const accountNum = user ? user.account : null;
  
      if (accountNum) {
        dispatch(fetchAccountDetails(accountNum));
        dispatch(fetchOpenPositions(accountNum));
  
        connectToTradeSocket(accountNum, (deal) => {
          if (deal.currentPrice > 0) {
            dispatch(removePosition(deal.positionid));
          } else {
            const newPosition = {
              positionid: deal.positionid,
              symbol: deal.symbol,
              volume: deal.lotsize,
              type: deal.action === "1" ? "SELL" : deal.action==="0"? "BUY" : "",
              price: deal.price,
              commission: deal.commssion,
              reason: deal.reason,
              profit: deal.profit,
              currentPrice: deal.currentPrice,
              sl: deal.SL,
              tp: deal.TP,
              open_time_formated: new Date(deal.opentime * 1000).toLocaleString(), // adjust if needed
            };
            dispatch(addPosition(newPosition));
          }
        });
  
        return () => {
          disconnectFromTradeSocket();
        };
      }
    }, [dispatch]);

  // useEffect(() => {
  //   const user = JSON.parse(localStorage.getItem('user'));
  //   const account = user ? user.account : null;

  //   if (account) {
  //     dispatch(fetchOpenPositions(account));

  //     const channel = subscribeToOrderChannel(account, (data) => {
  //       if (data && data.order) {
  //         if (data.order.current_price > 0) {
  //           dispatch(removePosition(data.order.position_id));
  //         } else {
  //           const newPosition = {
  //             positionid: data.order.position_id,
  //             symbol: data.order.symbol,
  //             volume: data.order.lot_size,
  //             type: data.order.type,
  //             price: data.order.price,
  //             commssion: data.order.commission,
  //             reason: data.order.reason,
  //             profit: data.order.profit,
  //             currentPrice: data.order.current_price,
  //             sl: data.order.sl,
  //             tp: data.order.tp,
  //             open_time_formated: data.order.open_time
  //           };
  //           dispatch(addPosition(newPosition));
  //         }
  //       }
  //     });

  //     return () => unsubscribeFromOrderChannel(account);
  //   } else {
  //     console.error('Account not found in local storage.');
  //   }
  // }, [dispatch]);

  const handleTouchEnd = () => {
    if (longPressTimeout.current) {
      clearTimeout(longPressTimeout.current);
    }
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const toggleBulkModal = () => {
    setIsBulkModalOpen(!isBulkModalOpen);
  };

  useEffect(() => {
    const handlePopState = (event) => {
      // If the user goes back, navigate them to the home page
      navigate('/');
    };

    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);

  return (
    <div>
      <Row>
        <Col xs={12}>
          <AccountDetails />
          <h6 className='fw-bold'>Positions</h6>
          <Card className='bg-transparent'>
            <CardBody className="p-0">
              <ListGroup>
                {
                  // loading ? (
                  //   <div className="text-center">
                  //     <Spinner size="sm" color="primary" /> Loading...
                  //   </div>
                  // )
                  //   :
                  error ? (
                    <div colSpan="11" className="text-center text-danger">
                      {" Page you are looking for doesn't exit or an other error ocurred or temporarily unavailable."}<br />
                      {" Please try again."}
                    </div>
                  )
                    : positions?.length > 0 ? (
                      positions.map((position) => {
                        const symbolData = symbols[position.symbol];
                        const currentPrice = position.type === 'buy' ? symbolData?.bid : symbolData?.ask;
                        const profit = calculatedProfits[position.positionid];
                        return (
                          <ListGroupItem
                            className="px-1 py-1 bg-transparent"
                            key={position.positionid}
                            onClick={(event) => handleTouchStart(event, position, longPressTimeout, symbols, setCurrentPriceLp, setLongPressedPosition,
                              setIsModalOpen, calculatedProfits, setCp)}
                            onTouchEnd={handleTouchEnd}
                            style={{ cursor: 'pointer' }}
                          >
                            <div className="d-flex align-items-center">
                              <div className="flex-grow-1">
                                <div className="d-flex">
                                  <div className="flex-shrink-0">
                                    <h6 className="mb-0 fw-bold" style={{ fontSize: '16px' }}>
                                      {position.symbol}
                                      <span className="ms-1">
                                        <small className={`fw-semibold ${position.type === 'SELL' ? 'text-primary' : 'text-secondary'
                                          }`}
                                          style={{ fontSize: '16px' }}
                                        >{position.type.toLowerCase()}</small>
                                      </span>
                                      <span className="ms-1">
                                        <small
                                          className={`fw-semibold ${position.type === 'SELL' ? 'text-primary' : 'text-secondary'
                                            }`}
                                          style={{ fontSize: '16px' }}
                                        >{position.volume}</small>
                                      </span>
                                    </h6>
                                  </div>
                                </div>
                                <small className="text-muted" style={{ fontSize: '14px' }}>
                                  {position.price} → {currentPrice ? Number(currentPrice).toFixed(3) : position.price}
                                </small>
                              </div>
                              <div className="text-end flex-shrink-0">
                                <small
                                  className={profit < 0 ? "text-danger" : "text-secondary"}
                                  style={{ fontWeight: 700, fontSize: '16px' }}
                                >{profit || 0.00}</small>
                              </div>
                            </div>
                          </ListGroupItem>
                        );
                      })
                    ) : (
                      <p className='text-center mt-2'>No open positions available</p>
                    )}
              </ListGroup>
            </CardBody>
          </Card>
        </Col>
      </Row>


      <Modal

        isOpen={isBulkModalOpen}
        toggle={toggleBulkModal}
        centered
        id='positionModalMenu'
        style={{ bottom: '0', position: 'fixed', width: '100%', margin: '0 auto' }}
      >
        <ModalBody>
          <div className="action-btns mt-2 modal-content">
            <Button className="w-100" color="secondary" onClick={() => handleBulkOrderClose(positions, account, dispatch, toggleBulkModal)}>
              Close All Position
            </Button>
            <Button className="w-100" color="secondary" onClick={() => { handleLosingPositionsClose(positions, account, calculatedProfits, dispatch, toggleBulkModal) }}>
              Close Losing Positions
            </Button>
            <Button className="w-100" color="secondary" onClick={() => handleSellOrdersClose(positions, account, dispatch, toggleBulkModal)}>
              Close Sell Positions
            </Button>
            <Button className="w-100" color="secondary" onClick={() => {
              handleCloseAllPressedSymbolOrders(account, positions, longPressedPosition, dispatch, toggleBulkModal)
            }}>
              Close {longPressedPosition?.symbol} Positions
            </Button>

            <Button className="w-100" color="primary" onClick={() => { handleCloseAllPressedSymbolSellOrders(account, positions, longPressedPosition, dispatch, toggleBulkModal) }}>
              Close {longPressedPosition?.symbol} Sell Positions
            </Button>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={isModalOpen}
        toggle={toggleModal}
        centered
        id='positionModalMenu'
        style={{ bottom: '0', position: 'fixed', width: '100%', margin: '0 auto' }}
      >
        <ModalBody>

          <div className="pos-cnt px-2 prevent-select">
            <div className="d-flex justify-content-between ps-row pt-3">
              <h6 className="fs-5 mb-0 fw-bold p-0">
                {longPressedPosition?.symbol}
                <span className="ms-1">
                  <small className={`fw-bold ${longPressedPosition?.type === 'SELL' ? 'text-primary' : 'text-secondary'
                    }`}>{longPressedPosition?.type}</small>
                </span>
                <span className="ms-1">
                  <small className={`fw-bold ${longPressedPosition?.type === 'SELL' ? 'text-primary' : 'text-secondary'
                    }`}>{longPressedPosition?.volume}</small>
                </span>
              </h6>
              <small className="text-muted fs-6">
                <span>#{longPressedPosition ? longPressedPosition.positionid : ''}</span>
              </small>
            </div>

            <div className="d-flex justify-content-between ps-row align-items-center">
              <small className="text-muted fs-6">
                <span>{longPressedPosition ? longPressedPosition.price : ''}</span> &#8594;{' '}
                {/* <span>{currentPriceLp !== null ? currentPriceLp : '...'}</span> */}
                <span>{Number(modalCurrentPrice).toFixed(3)}</span>
                <p className={`mb-0 fw-bold ${modalDelta <= 0 ? "text-danger" : "text-secondary"}`}
                  style={{ marginTop: "-7px" }}
                >
                  <i className="ri-triangle-line "></i> = {modalDelta ? Number(modalDelta).toFixed(2)
                    : 0} ({deltaPercentageChange
                      ? Math.abs(Number(deltaPercentageChange)).toFixed(2) + "%"
                      : "0%"})
                  <i class={`${modalDelta <= 0 ? "ri-arrow-drop-down-line" : "ri-arrow-drop-up-line"} fs-3`}></i>
                </p>
              </small>
              <div className="text-end">
                <strong className={calculatedProfits[longPressedPosition?.positionid] < 0 ? "text-danger fs-4 fw-bolder" : "text-secondary fs-4 fw-bolder"}>
                  {calculatedProfits[longPressedPosition?.positionid] || ''}
                </strong>
              </div>
            </div>

            <div className="d-flex justify-content-between ps-row">
              <p className="mb-1">S/L: {longPressedPosition?.sl}</p>
              {/* <span>-</span> */}
              <p className="mb-1">Swap:{longPressedPosition?.swap}</p>
            </div>
            <div className="d-flex justify-content-between ps-row mb-0 border-0" >
              <p className="mb-1">T.P: {longPressedPosition?.tp} </p>
              {/* <span>-</span>  */}
              <p className="mb-1">{longPressedPosition ? longPressedPosition.open_time_formated : ''}</p>
            </div>
          </div>
          <div className="action-btns mt-2">
            <Button className="w-100" color="secondary" onClick={() => {
              // Navigate to the CloseOrder component and pass the necessary data
              setCp(calculatedProfits[longPressedPosition?.positionid])
              dispatch(setClickedSymbolData(longPressedPosition.symbol));
              navigate('/close-order', {
                state: {
                  position: longPressedPosition, // Send the long-pressed position data
                  profit: cp
                },
              });
              toggleModal();
            }}>
              Close Position
            </Button>
            <Button className="w-100" color="secondary" onClick={() => { }}>
              Modify Position
            </Button>
            <Button className="w-100" color="secondary" onClick={() => {
              navigate('/symbol-detail');
              dispatch(setSelectedSymbol(longPressedPosition ? longPressedPosition.symbol : ''));

              toggleModal();
            }}>
              Trade
            </Button>
            <Button className="w-100" color="secondary" onClick={() => {
              toggleTab("3");
              toggleModal();
            }}>
              Chart
            </Button>

            <Button className="w-100" color="primary" onClick={() => {
              toggleModal()
              toggleBulkModal()
            }}>
              Bulk Operations...
            </Button>
          </div>
        </ModalBody>
      </Modal>

    </div >
  );
};


export default OpenPositionsMobile;
